import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import VendorSideBar from "../../Components/Vendor/VendorSideBar";
import VendorAllOrder from "../../Components/Vendor/VendorAllOrder";

const VendorAllOrdersPage = () => {
  return (
    <Container>
      <Row className="py-3">
        <Col sm="3" xs="2" md="2">
          <VendorSideBar />
        </Col>
        <Col sm="9" xs="10" md="10">
        <VendorAllOrder/>
        </Col>
      </Row>
    </Container>
  );
};

export default VendorAllOrdersPage;
